import React from 'react'

export default function BotLoadingMessage() {
    return (
        <div className="flex items-center justify-center h-screen bg-gradient-to-r from-blue-500 to-indigo-600">
        <h1 className="text-white text-3xl font-bold animate-fade-bounce m-4"> 
            این بات در حال راه‌اندازی است...
        </h1>
        <style>
            {`
            @keyframes fade-bounce {
              0% { opacity: 0; transform: translateY(-20px); }
              50% { opacity: 0.5; transform: translateY(0px); }
              100% { opacity: 1; transform: translateY(-5px); }
            }
            .animate-fade-bounce {
              animation: fade-bounce 1.5s ease-in-out  alternate;
            }
            `}
        </style>
    </div>
    )
}
